<template>
  <v-dialog v-model="passwordResetDialog" max-width='300'>
    <v-btn color="primary" block slot="activator">Send Password Reset Instructions</v-btn>
    <v-card>
      <v-card-title>
        <h2 class="headline">Reset Password?</h2>
      </v-card-title>
      <v-card-text>
        <p v-if="toSelf">
        This will send an email to {{ email }} with instructions to reset your password. The password will not be changed until you proceed with the reset instructions.
        </p>
        <p v-else>This will send an email to {{ email }} with instructions to reset their password. The password will not be changed until they proceed with the reset instructions.</p>
      </v-card-text>
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-btn color="grey" flat @click="passwordResetDialog = false">Nevermind</v-btn>
        <v-btn color="success" @click="sendPasswordReset">Send the Email</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [
    'email',
    'toSelf',
  ],
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    exampleComputed: function () {
      return this.example
    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      passwordResetDialog: false,
    }
  },
  methods: {
    sendPasswordReset () {
      this.$store.dispatch('userAuth/requestPasswordReset', this.email)
        .then(() => {
          this.passwordResetDialog = false
          this.$store.dispatch('global/showSnackbarSuccess', { message: 'A password reset email has been sent!' })
        })
        .catch(err => {
          this.passwordResetDialog = false
          this.$store.dispatch('global/showSnackbarError', { message: 'Something went wrong sending that password reset.' })

        })
    },
  },
}
</script>

<style scoped>
</style>
